<template>
  <div>
    <b-navbar toggleable="sm" type="dark" variant="primary">
      <b-navbar-toggle target="nav-text-collapse"></b-navbar-toggle>
      <b-navbar-brand>Accounting Tool</b-navbar-brand>
    </b-navbar>
    <div class="position-absolute w-100 h-100 d-flex align-items-center bg-auth">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="row">
              <div class="col-12 col-md-5 col-xl-7">
                <div class="text-center align-items-center">
                  <img src="../../public/piggy_bank.svg" alt="Abrechnung">
                </div>
              </div>
              <div class="col-12 col-md-5 col-xl-4 order-md-1 my-2">
                <h1 class="display-4 text-center mb-3">
                  Login
                </h1>
                <p class="text-muted text-center mb-5">
                  Zugang zum StudyHelp Abrechnungstool
                </p>
                <b-button @click="login" variant="primary" size="lg" class="mb-3" block>
                  Login
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import security from '@/services/security'

export default {
  name: 'Login',

  methods: {
    login () {
      window.location.href = security.buildLoginUrl().toString()
    }
  }
}
</script>

<style scoped>

</style>
